(() => {
  const widgetSelector = '#MainContent .jdgm-review-widget[data-product-id]';
  const imageSelector = '.jm-media-thumbnail-list__thumbnail img,.jdgm-rev__pics img';
  const states = new Map();

  function mediaKey(value) {
    try { const url = new URL(value, location.href); return url.origin + url.pathname; }
    catch { return null; }
  }
  function enhancePhotos(widget) {
    const originals = new Map();
    const data = window.jdgm?.data?.reviewWidget?.[widget.dataset.productId];
    for (const review of [...(data?.reviews || []), ...(data?.primary_language_reviews || []), ...(data?.other_language_reviews || [])]) {
      for (const picture of review.pictures_urls || []) {
        const original = picture.original || picture.huge;
        if (original && mediaKey(original)) originals.set(mediaKey(original), original);
      }
    }
    for (const photo of data?.photo_gallery || []) {
      const original = photo.original || photo.originalUrl || photo.huge;
      if (original && mediaKey(original)) originals.set(mediaKey(original), original);
    }
    for (const img of widget.querySelectorAll(imageSelector)) {
      if (img.closest('[aria-label="Play review video"]')) continue;
      const anchor = img.closest('a');
      const supplied = anchor?.dataset.mfpSrc || originals.get(mediaKey(img.src));
      const candidates = (img.getAttribute('srcset') || '').split(',').map(entry => {
        const [url, descriptor = '1x'] = entry.trim().split(/\s+/);
        return {url, size: parseFloat(descriptor) || 0};
      }).filter(entry => mediaKey(entry.url) === mediaKey(img.src));
      candidates.sort((a, b) => b.size - a.size);
      const best = supplied || candidates[0]?.url;
      if (best && mediaKey(best) === mediaKey(img.src)) {
        if (img.src !== best) img.src = best;
        if (img.hasAttribute('srcset')) img.removeAttribute('srcset');
      }
    }
  }
  function connect(widget) {
    if (states.has(widget)) return;
    const state = {settled: false};
    states.set(widget, state);
    widget.addEventListener('change', event => {
      if (event.isTrusted) state.settled = true;
    }, true);
    widget.addEventListener('click', event => {
      if (event.isTrusted && event.target.closest('.jdgm-paginate,.jm-pagination-controls,.jm-load-more-pagination,[role="tab"]')) state.settled = true;
    }, true);
    const refresh = () => {
      // Wait for the mounted native component; server-rendered selects have no Vue handler.
      if (!state.settled && widget.classList.contains('jdgm-widget-revamp')) {
        const select = widget.querySelector('select.jdgm-sort-dropdown,select.jm-sort-filter__select');
        if (select && [...select.options].some(option => option.value === 'pictures_first')) {
          state.settled = true;
          widget.dataset.damReviewDefault = 'native-pictures-first';
          if (select.value !== 'pictures_first') {
            select.value = 'pictures_first';
            select.dispatchEvent(new Event('change', {bubbles: true}));
          }
        }
      }
      enhancePhotos(widget);
    };
    state.observer = new MutationObserver(refresh);
    state.observer.observe(widget, {childList: true, subtree: true, attributes: true, attributeFilter: ['src', 'srcset', 'class']});
    refresh();
  }
  function init() { for (const widget of document.querySelectorAll(widgetSelector)) connect(widget); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once: true});
  else init();
  document.addEventListener('shopify:section:load', init);
  window.addEventListener('pagehide', () => { for (const state of states.values()) state.observer.disconnect(); });
  window.addEventListener('pageshow', event => {
    if (!event.persisted) return;
    for (const [widget, state] of states) {
      state.observer.observe(widget, {childList: true, subtree: true, attributes: true, attributeFilter: ['src', 'srcset', 'class']});
      enhancePhotos(widget);
    }
  });
})();
